export default{
  TotalMember: 'Tổng số người toàn đơn vị:',
  defaultRoleDesc:'Thiết lập mặc định của hệ thống',
  userManagerTitle:"Người dùng - Vai trò",
  rollAppTabName:"Vai trò",
  rollUserTabName:"Người dùng",
  listRoleAppTitle:"Danh sách vai trò",
  placeholderRightNavRolApp:"Tìm theo Họ và tên/Email/Điện thoại di động",
  txtBtnChooseUser:"Chọn người dùng",
  txtBtnFilter:"Lọc",
  addRoleApp:"Thêm vai trò",
  editRoleApp:"Sửa vai trò",
  viewRoleUser:"Xem vai trò",
  deleteRoleApp:"Xóa vai trò",
  placeHolderAddNameRole:"Nhập tên vai trò",
  placeHolderAddDescriptionRole:"Nhập diễn giải",
  Placeholder:{
    phSearchOrg:'Tìm kiếm đơn vị',
    phSearchStatus:'Chọn trạng thái',
    FullName:'Nhập họ và tên',
    DateOfBirth:'Ngày sinh',
    Email:'Nhập email',
    Mobile:'Nhập số điện thoại',
    WorkPhone:'Nhập số điện thoại cơ quan',
    JobTitle:'Chọn chức vụ/chức danh',
    Org:'Chọn đơn vị',
    OrgUnit:'Chọn phòng ban',
    Position:'Vị trí',
  },
  cancelFilter: "Bỏ lọc",
  cancelSelection:"Bỏ chọn",
  Message: {
    InActive:
            "Bạn có chắc chắn muốn cho ngừng hoạt động {0} <b>{1}</b> đã chọn không?",
    Active:
            "Bạn có chắc chắn muốn cho kích hoạt {0} <b>{1}</b> đã chọn không?",
    SentActiveMail:
            "Bạn có chắc chắn muốn gửi email kích hoạt tài khoản cho người dùng đã chọn không?",
    AllocateAccount: "Bạn có chắc chắn muốn cấp lại tài khoản cho người dùng đã chọn không?",
    RequiredUserRole: "Vai trò người dùng không được để trống"
  },
  Title: {
    Retire: "Nghỉ hưu người dùng",
    Active: "Kích hoạt người dùng",
    InActive: "Ngừng hoạt động người dùng",
    SentActiveMail: "Gửi mail kích hoạt tài khoản",
    AddUser:'Thêm người dùng',
    EditUser:'Sửa người dùng',
    TransferUser:'Vui lòng chọn phòng ban các cá nhân dưới đây thực hiện điều chuyển đến',
    AllocateAccount: "Cấp lại tài khoản",
    LiveChat: "Liên hệ với tư vấn viên"

  },
  IsHandOverTask: 'Điều phối bàn giao công việc',
  IsViewAllData: 'Xem dữ liệu toàn đơn vị', 
  BtnText:{
    sendActiveEmail:"Gửi email kích hoạt",
    transferUser:"Điều chuyển",
    allocateAccount: "Cấp lại tài khoản"
  },
  UserStatus:{
    Active: "Hoạt động",
    InActive: "Ngừng hoạt động",
    Retire: "Nghỉ hưu",

    Waiting:"Chờ xác nhận",
    Activated:"Đang hoạt động",
    Deactivated:"Ngừng hoạt động",
    Deleted:"Đã xóa",
    Retired:"Nghỉ hưu",
  },
  WokStatus:{
    Working: "Đang làm việc",
    Retired:"Nghỉ hưu",
  },
  Terms:{
    InActive: 'InActive',
    Active: 'Active',
    Retire: 'Retire',
    Delete: 'Deleted',
    User: 'người dùng',
    MultiUser: 'người dùng',
        
    RoleName:'Tên vai trò'
  },

  saveSuccess: "Lưu người dùng thành công",
  saveFail: "Lưu không thành công",
  updateSuccess: "Sửa người dùng thành công",
  importSuccess: "Nhập khẩu người dùng thành công",
  updateFail: "Sửa không thành công",
  deleteSuccess: "Xóa người dùng thành công",
  deleteFail: "Xóa không thành công",
  addRoleAppBtn: "Thêm vai trò",
  chooseUserBTn: "Chọn người dùng",
  addUserBTn: "Thêm người dùng",
  messageExistEmail: `Email này đã được sử dụng bởi người dùng <b class="font-bold">{0}</b>. Vui lòng thiết lập email khác`,

  deleteQuestionRole: `Bạn có chắc chắn muốn xóa vai trò <b class="font-bold">{0}</b> đã chọn không?`,
  addUserToRoleTitle: "Chọn người dùng (Vai trò: {0})",
  deleteQuestionOneUser: 'Bạn có chắc chắn muốn xóa người dùng <b class="font-bold">{0} </b> đã chọn không?',
  deleteQuestionMulUser: 'Bạn có chắc chắn muốn xóa người dùng đã chọn không?',
  btnSaveTxt:"Lưu",
  btnCancelTxt:"Hủy",
  btnYesTxt:"Có",
  btnRenewTxt:"Lưu và thêm mới",
  btnNoTxt:"Không",
  toggleDetail: "Xem chi tiết {0} hạng mục",
  txtEdit:'Sửa',
  txtDelete:'Xóa',
  InputLabel:{
    FullName:'Họ và tên',
    DateOfBirth:'Ngày sinh',
    Email:'Email',
    Mobile:'Điện thoại di động',
    WorkPhone:'Điện thoại cơ quan',
    JobTitle:'Chức vụ/Chức danh',
    Org:'Đơn vị',
    OrgUnit:'Phòng ban',
    Position:'Vị trí',
    SendActiveEmail:'Gửi email kích hoạt tài khoản',
    Required:' *',
    WorkStatus: 'Tình trạng làm việc',
    Role: 'Vai trò',
    RoleExpand: 'Phân quyền mở rộng'
  },
  NotificationChangeDepartment: 'Một số hồ sơ được cập nhật phòng ban mới đã có phát sinh công việc <b>chưa hoàn thành.</b> Vui lòng thực hiện <b>Điều phối bàn giao công việc</b> của những cá nhân này sau khi thực hiện đồng bộ xong.'
}